
import { motion } from "framer-motion";

const EmailPreview = () => {
  return (
    <div className="max-w-2xl mx-auto">
      <div className="bg-white rounded-lg shadow-lg overflow-hidden border border-gray-200">
        {/* Email Header */}
        <div className="bg-[#f9f8f5] px-8 py-6 border-b border-gray-200">
          <div className="flex items-center justify-center">
            <div className="font-funnel font-semibold text-3xl text-[#374151]">
              qwip
            </div>
          </div>
        </div>

        {/* Email Body */}
        <div className="px-8 py-10">
          <motion.div
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
          >
            <h1 className="text-2xl font-bold text-[#374151] mb-6 text-center">
              Thanks for joining our waitlist!
            </h1>
            
            <div className="space-y-4 text-gray-700 leading-relaxed">
              <p>Hi there,</p>
              
              <p>
                We're thrilled you've joined the qwip community! You're now part of an exclusive group 
                who will be first to experience the future of flexible workspaces.
              </p>
              
              <p>
                We'll be in touch as soon as we begin rolling out pods in your area. In the meantime, 
                feel free to browse our curated collection of quiet spots across London that we 
                recommend for remote work and video calls.
              </p>
              
              <div className="bg-[#f9f8f5] rounded-lg p-6 my-6">
                <p className="text-sm text-gray-600 mb-3 font-medium">
                  Discover great spots now:
                </p>
                <a 
                  href="#" 
                  className="inline-block bg-[#2563eb] text-white px-6 py-3 rounded-lg font-medium hover:bg-[#1d4ed8] transition-colors"
                >
                  Browse Quiet Spots
                </a>
              </div>
              
              <p>
                Thanks for being part of the journey as we build something special.
              </p>
              
              <p className="font-medium">
                Best,<br />
                The qwip team
              </p>
            </div>
          </motion.div>
        </div>

        {/* Email Footer */}
        <div className="bg-[#374151] px-8 py-6 text-center">
          <div className="font-funnel font-semibold text-lg text-white mb-2">
            qwip
          </div>
          <p className="text-gray-300 text-sm">
            Flexible workspaces, anywhere
          </p>
          <div className="mt-4 space-x-4 text-sm">
            <a href="#" className="text-gray-300 hover:text-white transition-colors">
              Unsubscribe
            </a>
            <span className="text-gray-500">|</span>
            <a href="#" className="text-gray-300 hover:text-white transition-colors">
              Update preferences
            </a>
          </div>
        </div>
      </div>
      
      <div className="mt-6 text-center">
        <p className="text-sm text-gray-500">
          Email preview - this is how users will see our waitlist confirmation
        </p>
      </div>
    </div>
  );
};

export default EmailPreview;
